import { SxProps } from '@mui/material';

export const LogoStyles: SxProps = {
  background: 'white',
  height: '48px',
};
